import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface Goals {
  metaVendas: number;
  metaReceita: number;
  setMetaVendas: (v: number) => void;
  setMetaReceita: (v: number) => void;
}

const GoalsContext = createContext<Goals | undefined>(undefined);

export const GoalsProvider = ({ children }: { children: ReactNode }) => {
  const [metaVendas, setMetaVendasState] = useState<number>(() => {
    const saved = localStorage.getItem('metaVendas');
    return saved ? Number(saved) : 0;
  });
  const [metaReceita, setMetaReceitaState] = useState<number>(() => {
    const saved = localStorage.getItem('metaReceita');
    return saved ? Number(saved) : 0;
  });

  useEffect(() => {
    localStorage.setItem('metaVendas', String(metaVendas));
  }, [metaVendas]);
  useEffect(() => {
    localStorage.setItem('metaReceita', String(metaReceita));
  }, [metaReceita]);

  const setMetaVendas = (v: number) => setMetaVendasState(v);
  const setMetaReceita = (v: number) => setMetaReceitaState(v);

  return (
    <GoalsContext.Provider value={{ metaVendas, metaReceita, setMetaVendas, setMetaReceita }}>
      {children}
    </GoalsContext.Provider>
  );
};

export const useGoals = () => {
  const ctx = useContext(GoalsContext);
  if (!ctx) throw new Error('useGoals deve ser usado dentro de GoalsProvider');
  return ctx;
};
